import { useEffect, useState } from 'react';
import './Preloader.css';

export default function Preloader({ onFinish }) {
	const [progress, setProgress] = useState(0);
	const [isPageReady, setIsPageReady] = useState(false);
	const [isFinishing, setIsFinishing] = useState(false);
	const [isHidden, setIsHidden] = useState(false);

	useEffect(() => {
		const handleWindowLoaded = () => {
			setIsPageReady(true);
		};

		if (document.readyState === 'complete') {
			setIsPageReady(true);
		} else {
			window.addEventListener('load', handleWindowLoaded);
		}

		return () => {
			window.removeEventListener('load', handleWindowLoaded);
		};
	}, []);

	useEffect(() => {
		if (isHidden) return;

		const interval = setInterval(() => {
			setProgress((prev) => {
				if (!isPageReady) {
					if (prev >= 92) return prev;
					const step = prev < 35 ? 3 : prev < 68 ? 2 : 1;
					return Math.min(prev + step, 92);
				}

				if (prev >= 100) {
					clearInterval(interval);
					return 100;
				}

				return Math.min(prev + 5, 100);
			});
		}, 42);

		return () => clearInterval(interval);
	}, [isPageReady, isHidden]);

	useEffect(() => {
		if (progress === 100 && isPageReady) {
			const finishTimer = setTimeout(() => {
				setIsFinishing(true);
			}, 180);

			const hideTimer = setTimeout(() => {
				setIsHidden(true);
				onFinish?.();
			}, 1250);

			return () => {
				clearTimeout(finishTimer);
				clearTimeout(hideTimer);
			};
		}
	}, [progress, isPageReady, onFinish]);

	if (isHidden) return null;

	return (
		<div
			className={`site-preloader ${
				isFinishing ? 'site-preloader--finish' : ''
			}`}>
			<div className='site-preloader__curtain site-preloader__curtain--left' />
			<div className='site-preloader__curtain site-preloader__curtain--right' />

			<div className='site-preloader__content'>
				<div className='site-preloader__glow' />

				<div className='site-preloader__spinner'>
					<svg
						className='site-preloader__svg'
						viewBox='0 0 200 200'
						aria-hidden='true'>
						<circle
							className='site-preloader__ring site-preloader__ring--purple'
							cx='100'
							cy='100'
							r='44'
							pathLength='100'
						/>
						<circle
							className='site-preloader__ring site-preloader__ring--green'
							cx='100'
							cy='100'
							r='58'
							pathLength='100'
						/>
						<circle
							className='site-preloader__ring site-preloader__ring--orange'
							cx='100'
							cy='100'
							r='72'
							pathLength='100'
						/>
					</svg>

					<div className='site-preloader__percent'>{progress}%</div>
				</div>
			</div>
		</div>
	);
}
